import api from "@/api/index";

/**
 * Service pour la gestion des propriétaires
 */
export const proprietairesService = {
  /**
   * Récupère la liste des propriétaires
   * @returns {Promise} Promesse contenant la liste des propriétaires
   */
  async getProprietaires() {
    try {
      const response = await api.get("/proprietaires");
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des propriétaires:", error);
      throw error;
    }
  },

  /**
   * Crée un nouveau propriétaire
   * @param {Object} proprietaireData - Les données du propriétaire à créer
   * @param {string} proprietaireData.firstName - Prénom du propriétaire
   * @param {string} proprietaireData.lastName - Nom du propriétaire
   * @param {string} proprietaireData.email - Email du propriétaire
   * @param {string} proprietaireData.phoneNumber - Numéro de téléphone du propriétaire
   * @returns {Promise} Promesse contenant les données du nouveau propriétaire
   */
  async createProprietaire(proprietaireData) {
    try {
      const response = await api.post("/proprietaires", proprietaireData);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la création du propriétaire:", error);
      throw error;
    }
  },
};
